export default __webpack_public_path__ + "static/2-45ab6d42cd5440280f4fd8ac34cea10b.jpg";